import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoStyledList } from "@/components/seo/SeoStyledList";
import { SeoNumberedSteps } from "@/components/seo/SeoNumberedSteps";
import { SeoHighlightBox } from "@/components/seo/SeoHighlightBox";
import { Lock } from "lucide-react";

const KomikNaKawalerski = () => (
  <SeoPageLayout title="Komik na" titleAccent="wieczór kawalerski i panieński">
    <SeoSection title="Stand-up na wieczór kawalerski i panieński">
      <p>Szukasz oryginalnego pomysłu na wieczór kawalerski lub panieński? Profesjonalny występ komediowy to idealna atrakcja, która rozbawi całą grupę i stworzy niezapomniane wspomnienia. Nasi komicy przygotowują spersonalizowany materiał nawiązujący do przyszłych nowożeńców - zabawne anegdoty, roasty i interaktywne elementy, które sprawią, że ten wieczór będzie wyjątkowy.</p>
    </SeoSection>

    <SeoSection title="Co zawiera występ na kawalerskim/panieńskim?">
      <SeoStyledList items={[
        "Spersonalizowany materiał komediowy o parze młodej",
        "Roast przyszłego pana młodego lub panny młodej",
        "Interaktywne zabawy z udziałem gości",
        "Anegdoty zebrane wcześniej od przyjaciół i rodziny",
        "Występ dopasowany do charakteru grupy - od eleganckiego po odważny humor"
      ]} />
    </SeoSection>

    <SeoSection title="Gdzie organizujemy występy?">
      <p>Nasi komicy występują w dowolnym miejscu - w restauracjach, klubach, wynajętych salach, apartamentach, a nawet na łonie natury. Dostosowujemy się do planu imprezy i możemy wystąpić jako główna atrakcja wieczoru lub element większego programu.</p>
    </SeoSection>

    <SeoSection title="Zamów komika na wieczór kawalerski">
      <p>Skontaktuj się z nami odpowiednio wcześniej - im więcej informacji o parze młodej i gościach nam przekażesz, tym lepiej spersonalizujemy występ. Gwarantujemy dyskrecję i profesjonalizm na najwyższym poziomie.</p>
      <SeoHighlightBox icon={Lock}>
        Gwarantujemy pełną dyskrecję - wszystkie informacje zebrane na potrzeby występu są traktowane poufnie.
      </SeoHighlightBox>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikNaKawalerski;
